import { FileExtended } from "ui/components/FileUpload/FileDropZone/types";
import {
  FleetDocumentEditFormValues,
  FleetDocumentUpload,
  FleetDocument,
  FleetDocumentRow,
  FleetDocumentType,
  FleetDocumentUploadRow,
} from "./types";

export const transformFleetDocumentRow= (
  res: any
): FleetDocumentRow=> {
  return {
    id: res.id,
    name: res.name,
    description: res.description,
    documentType: res.documentType,
    // BE vraća `vehicle` samo kad se search pozove bez entityId-a (globalni
    // pregled). Za per-vehicle stranicu polje je null i ne renderira se.
    vehicle: res.vehicle ?? null,
    created: res.created,
    childRows: res.uploads ? res.uploads.map((u: any) => transformFleetDocumentUploadRow(u, res)) : [],
  };
};

export const transformFleetDocumentOnCreate = (
  entityId: string,
  entityName: string,
  formValues: FleetDocumentEditFormValues,
  uploads: FleetDocumentUpload[]
): any => ({
  documentTypeId: formValues.documentTypeId,
  entityId: entityId,
  entityName: entityName,
  name: formValues.name,
  description: formValues.description,
  uploadIds: uploads.map((u) => u.id),
});


export const transformFleetDocumentOnUpdate = (
  entityId: string,
  entityName: string,
  formValues: FleetDocumentEditFormValues,
  uploads: FleetDocumentUpload[]
): any => ({
  documentTypeId: formValues.documentTypeId,
  entityId: entityId,
  entityName: entityName,
  name: formValues.name,
  description: formValues.description,
  uploadIds: uploads.map((u) => u.id),
});


export const transformFleetDocument = (res: any): FleetDocument => {
  return {
    id: res.id,
    name: res.name,
    description: res.description,
    documentType: res.documentType,
    // vehicle: res.vehicle,
    created: res.created,
    uploads: res.uploads,
  };
};

export const transformFleetDocumentToFormValues = (
  document: FleetDocument
): FleetDocumentEditFormValues => {
  const fakeFile: Partial<FileExtended> = {
    id: document.id,
    name: document.name || "",
  };

  return {
    id: document.id,
    name: document.name,
    description: document.description,
    documentTypeId: document.documentType.id,
    files: [fakeFile as FileExtended],
  };
};

export const transformFleetDocumentEditFormValues = (
  res: FleetDocument
): FleetDocumentEditFormValues => {

  const files: FileExtended[] = [];

  if (res.uploads && Array.isArray(res.uploads)) {
    res.uploads.forEach((u) => {
      const dummyBlob = new Blob([""], { type: u.contentType });

      const fakeFile: FileExtended = Object.assign(
        new File([dummyBlob], u.originalFileName, {
          type: u.contentType,
          lastModified: new Date(u.created).getTime(),
        }),
        {
          id: u.id,
          url: u.url,
          isNew: false,
        }
      );

      files.push(fakeFile);
    });
  }

  return {
    id: res.id,
     name: res.name,
    description: res.description,
    documentTypeId: res.documentType?.id,
    files,
  };
};


export const transformFleetDocumentType = (
  res: any
): FleetDocumentType => {
  return {
    id: res.id,
    name: res.name,
  };
};

export const transformFleetDocumentUpload = (
  res: any
): FleetDocumentUpload => {

  return {
    id: res.id,
    originalFileName: res.originalFileName,
    fileExtension: res.fileExtension,
    fileSizeKb: res.fileSizeKb,
    contentType: res.contentType,
    created: res.created,
    url: res.url
  };
};

export const transformFleetDocumentUploadRow = (
  res: any, parent: any
): FleetDocumentUploadRow => {
  return {
    documentId: parent.id,
    id: res.id,
    originalFileName: res.originalFileName,
    created: res.created,
    url: res.url,
  };
};
